import { Constant } from "../../utils/Constant";
import Logger from "../../utils/Logger";

const CACHE_NAME = "imageCache";

export const imageCacheService = {
  async getCachedImage(src: string, cacheDuration?: number): Promise<string> {
    // Le Cache API ne supporte pas les URLs blob:
    if (src.startsWith("blob:")) {
      return src;
    }

    try {
      const cache = await caches.open(CACHE_NAME);
      const cachedResponse = await cache.match(src);

      if (cachedResponse) {
        const dateHeader = cachedResponse.headers.get("date");
        if (dateHeader) {
          const cachedTime = new Date(dateHeader).getTime();
          const currentTime = Date.now();
          const cacheExpirationTime = cachedTime +
            (cacheDuration ?? Constant.CACHE_DURATION_DAYS) *
              24 *
              60 *
              60 *
              1000;

          if (currentTime < cacheExpirationTime) {
            return src; // Image encore valide, on retourne l'URL originale
          } else {
            await cache.delete(src); // Supprime l'image expirée
          }
        }
      }

      // Image absente ou expirée, on la télécharge et on la stocke
      const response = await fetch(src);
      if (!response.ok) throw new Error("Image fetch failed");

      await cache.put(src, response.clone());
      return src;
    } catch (error) {
      Logger.error("Image caching error:", error);
      return src; // Fallback sur l'URL originale
    }
  },

  async clean() {
    Logger.debug("Cleaning cached images...");
    const cache = await caches.open(CACHE_NAME);
    const keys = await cache.keys();

    const currentTime = Date.now();

    for (const request of keys) {
      const response = await cache.match(request);
      if (response) {
        const dateHeader = response.headers.get("date");
        if (dateHeader) {
          const cachedTime = new Date(dateHeader).getTime();
          const daysSinceCache = (currentTime - cachedTime) /
            (24 * 60 * 60 * 1000);

          if (daysSinceCache > 7) {
            // Expiration à 7 jours (modifiable)
            await cache.delete(request);
          }
        }
      }
    }
  },
};
